// components/StickyHeaderWrapper.js
import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import { config } from '../config';

const StickyHeaderWrapper = ({ children, title, showBackButton = true, rightButtons = [], titleStyle = {} }) => {
  const navigation = useNavigation();

  if (!config.ENABLE_STICKY_HEADER || Platform.OS !== 'web') {
    // Si sticky désactivé ou pas sur web, afficher normalement
    return (
      <SafeAreaView style={styles.container} edges={['bottom']}>
        {children}
      </SafeAreaView>
    );
  }

  return (
    <SafeAreaView style={styles.container} edges={['bottom']}>
      {/* Header sticky personnalisé */}
      <View style={styles.stickyHeader}>
        <View style={styles.headerContent}>
          {showBackButton && navigation.canGoBack() && (
            <TouchableOpacity 
              style={styles.backButton}
              onPress={() => navigation.goBack()}
            >
              <Ionicons name="chevron-back" size={24} color="#fff" />
            </TouchableOpacity>
          )}
          
          <Text style={[styles.headerTitle, titleStyle]} numberOfLines={1}>
            {title}
          </Text>
          
          <View style={styles.rightButtonsContainer}>
            {rightButtons.map((button, index) => (
              <TouchableOpacity
                key={index}
                style={styles.headerButton}
                onPress={button.onPress}
              >
                <Ionicons name={button.icon} size={24} color="#fff" />
              </TouchableOpacity>
            ))}
          </View>
        </View>
      </View>

      {/* Contenu avec padding pour compenser le header */}
      <View style={styles.content}>
        {children}
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    backgroundColor: `rgba(0, 102, 204, ${config.STICKY_HEADER_OPACITY || 0.95})`,
    zIndex: 1000,
    borderBottomWidth: 0,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
    ...(config.STICKY_HEADER_BLUR && Platform.OS === 'web' && {
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
    }),
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 56,
    paddingHorizontal: 16,
  },
  backButton: {
    padding: 4,
    marginRight: 8,
  },
  headerTitle: {
    flex: 1,
    fontSize: 20,
    
    color: '#fff',
    fontFamily: 'Montserrat_600SemiBold',
    textAlign: 'left', // 🆕 Alignement à gauche
    marginLeft: 8,
  },
  rightButtonsContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerButton: {
    padding: 4,
    marginLeft: 8,
  },
  content: {
    flex: 1,
  },
});

export default StickyHeaderWrapper;